__turbopack_context__.v({
  "head": "styles-module__IYpskW__head",
  "heading": "styles-module__IYpskW__heading",
  "inner": "styles-module__IYpskW__inner",
  "node": "styles-module__IYpskW__node",
  "note": "styles-module__IYpskW__note",
  "numeral": "styles-module__IYpskW__numeral",
  "rail": "styles-module__IYpskW__rail",
  "section": "styles-module__IYpskW__section",
  "stepBody": "styles-module__IYpskW__stepBody",
  "stepTitle": "styles-module__IYpskW__stepTitle",
});
